import React, {useCallback, useContext, useEffect, useState} from 'react';
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid} from "@mui/material";
import Button from "@mui/material/Button";
import {companyUsername} from "../../../utils/RegisterUtils";
import CustomText from "../../widgets/inputs/CustomText";
import {useForm} from "react-hook-form";
import CircularProgress from "@mui/material/CircularProgress";
import {LoginStyle} from "../../../styles/pages/auth/LoginStyle";
import {AppContext, AuthContext} from "../../../App";
import {forgotPassword} from "../../../services/AuthServices";
import {setOpenSnackbar} from "../../../services/AppServices";
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import clsx from "clsx";


export const ForgotPasswordDialog = ({open, handleClose}) => {
	const classes = LoginStyle();
	const baseClasses = BaseStyle();
	const {handleSubmit, errors, control} = useForm({mode: "onChange"});
	const authContext = useContext(AuthContext);
	const appContext = useContext(AppContext);
	const [submit, setSubmit] = useState(false);
	
	const onSubmit = useCallback((data) => {
		setSubmit(true);
		forgotPassword(data.username.toUpperCase(), authContext.dispatch);
	}, [authContext.dispatch]);
	
	useEffect(() => {
		if (submit && !authContext.state.loadingSendNewPassword && authContext.state.errorSendNewPassword === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Controlla la mail che hai fornito in fase di registrazione", appContext.dispatch);
		} else if (submit && !authContext.state.loadingSendNewPassword && authContext.state.errorSendNewPassword.length > 1) {
			setSubmit(false);
			setOpenSnackbar("error", authContext.state.errorSendNewPassword, appContext.dispatch);
		}
	}, [handleClose, authContext.state.loadingSendNewPassword, authContext.state.errorSendNewPassword, appContext.dispatch, submit])
	
	return (
		<React.Fragment>
			<Dialog open={open} onClose={handleClose}
			        PaperProps={{className: clsx(baseClasses.roundBorder, baseClasses.shadow24)}}>
				<DialogTitle>
					<b>Password dimenticata?</b>
				</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Non preoccuparti! Inserisci qui sotto il tuo nome utente, riceverai una mail sulla casella postale che hai
						fornito in fase di registrazione.
					</DialogContentText>
					<form onSubmit={handleSubmit(onSubmit)}>
						<Grid container spacing={1}>
							<Grid item xs={12}>
								<CustomText
									control={control}
									rules={companyUsername}
									name={"username"}
									label={"Nome utente"}
									autoFocus={true}
									autoComplete={"given-name"}
									error={errors["username"]}
									inputProps={{
										className: classes.input
									}}
								/>
							</Grid>
						</Grid>
					</form>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} size={"small"} variant={"text"}
					        className={baseClasses.roundButton}>
						<b>Annulla</b>
					</Button>
					<Button onClick={handleSubmit(onSubmit)} size="small" disableElevation
					        variant={"contained"} color={"primary"} type={"submit"} disabled={submit}
					        className={baseClasses.roundButton} autoFocus>
						{
							submit ?
								<CircularProgress size={24}/> : <b>Invia nuova password</b>
						}
					</Button>
				</DialogActions>
			</Dialog>
		</React.Fragment>
	);
};
